import { useEffect, useRef } from "react";
import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
// const SOCKET_URL = "ws://localhost:3000";

export const useSocket = (setMetrics, meetingID, setCoachingLogs) => {
  const socketRef = useRef(null);

  useEffect(() => {
    if (meetingID) {
      try {
        socketRef.current = io(SOCKET_URL, {
          transports: ["websocket"],
          path: "/socket.io",
        });

        socketRef.current.on("connect", () => {
          console.log("🟢 Socket connected:", socketRef.current.id);
        });

        if (meetingID) {
          socketRef.current.emit("initMeeting", meetingID);
          console.log("📨 Emitted meetingID to server:", meetingID);
        }

        socketRef.current.on("sentimentUpdate", (data) => {
          setMetrics((prevMetrics) => ({
            ...prevMetrics,
            score: data.score,
            engagement: data.engagement,
            sentiment: data.sentiment,
          }));
        });

        socketRef.current.on("coachingTip", (data) => {
          setCoachingLogs((prevCoachingLogs) => [
            ...prevCoachingLogs,
            { suggestion: data.tip, timestamp: data.timestamp },
          ]);
        });

        socketRef.current.on("disconnect", () => {
          console.log("🔴 Socket disconnected");
        });
      } catch (error) {
        console.error("❌ Socket connection error:", error);
      }

      return () => {
        socketRef.current?.disconnect();
      };
    }
  }, [meetingID]);

  /**
   * Emit meeting ID to backend after SDK context is available.
   * @param {string} meetingID
   */
  const emitMeetingID = (meetingID) => {
    if (socketRef.current && socketRef.current.connected) {
      socketRef.current.emit("initMeeting", meetingID);
    } else {
      console.warn("⚠️ Socket not connected. Cannot emit meetingID.");
    }
  };

  return { socketRef, emitMeetingID };
};
